










import Vue from 'vue';

export default Vue.extend({
  metaInfo() {
    return {
      titleTemplate: 'Jamesway'
    };
  },
  name: 'App',
  components: {},
  data: () => ({}),
  computed: {}
});
